export const ERROR_MESSAGES = {
    empty_field: 'Required field.',
    incorrect_authorization: 'Incorrect login or password.',
    incorrect_sms_code: 'Invalid code'
};

export const FORM_NAME = {
    LOGIN: 'LOGIN',
    CODE: 'CODE'
};

export const POKEMON_API_KEY = '1cf24b30-3606-41ab-9abd-fc96dbcd39bf';
